import React from "react";
import {
  CHART_CTT,
  CHART_SPREAD,
  CHART_BID_ASK_QUANTITY,
  CHART_TYPE_SCATTER_PLOT,
  CHART_TYPE_LINE,
  CHART_TYPE_AREA_MIRRORED
} from "../../../services/managers/constants";
import styles from "./ChartLegend.css";
import _Aux from "../../_Aux";

class ChartLegend extends React.Component {
  shouldComponentUpdate(nextProps) {
    // Do not redraw if whiteboard is becoming obsolete
    return !nextProps.isObsolete;
  }

  render() {
    let legendDoc = null;
    let whichLegend = null;

    if (this.props.drawingsLen) {
      if (
        (this.props.selectedPrimaryChart === CHART_CTT &&
          this.props.selectedPrimaryChartType === CHART_TYPE_SCATTER_PLOT &&
          this.props.selectedComparisonChart === CHART_SPREAD &&
          this.props.selectedComparisonChartType === CHART_TYPE_LINE) ||
        (this.props.selectedComparisonChart === CHART_CTT &&
          this.props.selectedComparisonChartType === CHART_TYPE_SCATTER_PLOT &&
          this.props.selectedPrimaryChart === CHART_SPREAD &&
          this.props.selectedPrimaryChartType === CHART_TYPE_LINE)
      ) {
        // Cost To Trade (Scatter) + Spread (Line)
        whichLegend = (
          <_Aux>
            <label className={styles["buy"]}>
              <div className={[styles["legend"], styles["ctt-buy"]].join(" ")} /> Buy 
            </label>
            <label className={styles["sell"]}>
              <div className={[styles["legend"], styles["ctt-sell"]].join(" ")} /> Sell
            </label>
            <label className={styles["spread"]}>
              <div className={[styles["legend"], styles["spread-overlay"]].join(" ")} /> Spread
            </label>
          </_Aux>
        );
      } else if (
        (this.props.selectedPrimaryChart === CHART_CTT &&
          this.props.selectedPrimaryChartType === CHART_TYPE_SCATTER_PLOT &&
          this.props.selectedComparisonChart === CHART_BID_ASK_QUANTITY &&
          this.props.selectedComparisonChartType === CHART_TYPE_AREA_MIRRORED) ||
        (this.props.selectedComparisonChart === CHART_CTT &&
          this.props.selectedComparisonChartType === CHART_TYPE_SCATTER_PLOT &&
          this.props.selectedPrimaryChart === CHART_BID_ASK_QUANTITY &&
          this.props.selectedPrimaryChartType === CHART_TYPE_AREA_MIRRORED)
      ) {
        // Cost To Trade (Scatter) + Bid Ask Quantity (Area)
        whichLegend = (
          <_Aux>
            <label className={styles["buy-cost"]}>
              <div className={[styles["legend"], styles["ctt-buy"]].join(" ")} /> Buy Cost
            </label>
            <label className={styles["sell-cost"]}>
              <div className={[styles["legend"], styles["ctt-sell"]].join(" ")} /> Sell Cost
            </label>
            <label className={styles["bid-quantity"]}>
              <div className={[styles["legend"], styles["bid-overlay"]].join(" ")} /> Bid Quantity
            </label>
            <label className={styles["ask-quantity"]}>
              <div className={[styles["legend"], styles["ask-overlay"]].join(" ")} /> Ask Quantity
            </label>
          </_Aux>
        );
      } else if (
        (this.props.selectedPrimaryChart === CHART_SPREAD &&
          this.props.selectedPrimaryChartType === CHART_TYPE_LINE &&
          this.props.selectedComparisonChart === CHART_BID_ASK_QUANTITY &&
          this.props.selectedComparisonChartType === CHART_TYPE_AREA_MIRRORED) ||
        (this.props.selectedComparisonChart === CHART_SPREAD &&
          this.props.selectedComparisonChartType === CHART_TYPE_LINE &&
          this.props.selectedPrimaryChart === CHART_BID_ASK_QUANTITY &&
          this.props.selectedPrimaryChartType === CHART_TYPE_AREA_MIRRORED)
      ) {
        //  Spread (Line) + Bid Ask Quantity (Area)
        whichLegend = (
          <_Aux>
            <label className={styles["bid"]}>
              <div className={[styles["legend"], styles["bid-overlay"]].join(" ")} /> Bid
            </label>
            <label className={styles["ask"]}>
              <div className={[styles["legend"], styles["ask-overlay"]].join(" ")} /> Ask
            </label>
            <label className={styles["spread"]}>
              <div className={[styles["legend"], styles["spread-overlay"]].join(" ")} /> Spread
            </label>
          </_Aux>
        );
      } else if (this.props.selectedPrimaryChart === CHART_CTT && this.props.selectedPrimaryChartType === CHART_TYPE_SCATTER_PLOT) {
        // Cost To Trade (Scatter)
        whichLegend = (
          <_Aux>
            <label className={styles["buy"]}>
              <div className={[styles["legend"], styles["ctt-buy"]].join(" ")} /> Buy
            </label>
            <label className={styles["sell"]}>
              <div className={[styles["legend"], styles["ctt-sell"]].join(" ")} /> Sell
            </label>
            <label className={styles["mid-price"]}>
              <div className={[styles["legend"], styles["mid-price"]].join(" ")} /> Mid Price
            </label>
          </_Aux>
        );
      } else if (this.props.selectedPrimaryChart === CHART_SPREAD && this.props.selectedPrimaryChartType === CHART_TYPE_LINE) {
        // Spread (Line)
        whichLegend = (
          <_Aux>
            <label className={styles["spread"]}>
              <div className={[styles["legend"], styles["spread"]].join(" ")} /> Spread
            </label>
            <label className={styles["mid-price"]}>
              <div className={[styles["legend"], styles["mid-price"]].join(" ")} /> Mid Price
            </label>
          </_Aux>
        );
      } else if (this.props.selectedPrimaryChart === CHART_BID_ASK_QUANTITY && this.props.selectedPrimaryChartType === CHART_TYPE_AREA_MIRRORED) {
        // Bid Ask Quantity (Area Mirrored)
        whichLegend = (
          <_Aux>
            <label className={styles["bid"]}>
              <div className={[styles["legend"], styles["bid"]].join(" ")} /> Bid
            </label>
            <label className={styles["ask"]}>
              <div className={[styles["legend"], styles["ask"]].join(" ")} /> Ask
            </label>
            <label className={styles["mid-price"]}>
              <div className={[styles["legend"], styles["mid-price"]].join(" ")} /> Mid Price
            </label>
          </_Aux>
        );
      } else {
        whichLegend = <label>Legend not available.</label>;
      }

      legendDoc = <div className={styles["chart-legend-container"]}>{whichLegend}</div>;
    }

    return legendDoc;
  }
}

export default ChartLegend;



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartLegend/ChartLegend.js